import React from "react";
import { useParams } from "react-router-dom";

import { Page } from "modules/layout/Page";
import { EventList, useEventData } from "modules/events";

export const EventListPage = () => {
  const { siteId, unitId, deviceId } = useParams();
  const { eventData, isLoading: isEventDataLoading } = useEventData(
    siteId,
    unitId,
    deviceId,
    100
  );
  return (
    <Page>
      <EventList eventData={eventData} isLoading={isEventDataLoading} />
    </Page>
  );
};
